import Vue from "vue";
import VueMaterial from "vue-material";
console.log("*******************loading vue material***********");

Vue.use(VueMaterial);
